import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import './App.css';
import { AppActions } from './actions';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom'
import GoogleAds from 'react-google-ads'

const Header = styled.h1`
  background: #85cbcd;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  padding: 12px 0;
  margin-bottom: 16px;
`;

const MainContent = styled.div`
  width: 94%;
  max-width: 800px;
  margin: 0 auto;
`

const Card = styled.div`
  background: #fff;
  padding: 28px 20px;
  line-height: 1.6;
  font-size: 15px;
  @media (min-width: 700px) {
    padding: 30px 40px;
  }
`

const Point = styled.h2`
  display: block;
  margin: 0 auto 36px; 
  width: 80px;
  color: #444;
  background: linear-gradient(transparent 70%, #fbc78d 70%);
  text-align: center;
  font-size: 16px;
  font-weight: bold;
`

const DotOnly = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fbc78d;
  border-radius: 50%;
  margin-right: 6px;
`;

const Dot = styled.span`
  background: #fbc78d;
  border-radius: 50%;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  padding: 3px 4px;
  margin-right: 6px;
`;

const SubmitButton = styled.input`
  display: block;
  margin: 0 auto;
  background: #85cbcd;
  width: 200px;
  height: 46px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-appearance: none;
  max-width: 100%;
`

const TextBox = styled.input`
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 10px;
  height: 34px;
  width: 100%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-appearance: none;
  max-width: 100%;
  font-size: 17px;
`

const LabelText = styled.p`
  font-size: 13px;
  font-weight: bold;
  color: #666;
  margin-bottom: 4px;
`

const TextBoxWrap = styled.div`
  margin-bottom: 30px;
`

const DescImg = styled.img`
  display: block;
  border: 1px solid #ccc;
  width: 90%;
  margin: 10px auto 26px;
  padding: 4px;
  border-radius: 4px;
`

const Footer = styled.footer`
  background: #666;
  margin-top: 60px;
  font-size: 12px;
  padding: 16px 0;
  color: #fff;
  a {
    color: #fff;
  }
`

class TopScreen extends Component {
  state = {
    tweetNumber: 0,
    tweetImpression: 0,
    profileAccess: 0,
    newFollower: 0,
    nowFollower: 0,
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const {
      tweetNumber,
      tweetImpression,
      profileAccess,
      newFollower,
      nowFollower,
    } = this.state;

    this.props.calculation(
      tweetNumber,
      tweetImpression,
      profileAccess,
      newFollower,
      nowFollower,
    );

    this.props.history.push('/result');
  }

  render() {
    const {
      tweetNumber,
      tweetImpression,
      profileAccess,
      newFollower,
      nowFollower,
    } = this.state;

    ReactGA.initialize('UA-124198085-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  
    return (
      <div>
        <Header>
          フォロワー1000人までの道
        </Header>
        <MainContent>
          <Card style={{ marginBottom: '40px' }}>
            <Point>使い方</Point>
            <div>
              <p>Twitterアナリティクスの数値を入力すると、フォロワー数1000人突破までに必要なツイート数が表示されます。</p>
              <div style={{ margin: '38px 0px 20px', fontSize: '13px' }}>
                <p style={{ marginBottom: '14px' }} ><DotOnly />「当月」の数値を入力してください。</p>
                <a
                  href="/twitter-desc.png"
                  style={{ display: 'block' }}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <DescImg src="/twitter-desc.png" />
                </a>
              </div>
              <p style={{ fontSize: '13px' }}><DotOnly />
                詳しい使い方は
                <a href="https://growthhackoverlife.org/make-twitter-analysis-tool/" target="_blank" rel="noopener noreferrer" style={{ color: '#928484' }}>こちら</a>
              </p>
            </div>
          </Card>
          <Card style={{ marginBottom: '40px' }}> 
            <Point>分析する</Point>
            <form onSubmit={this.handleSubmit}>
              <ul>
                <li style={{ marginBottom: '40px' }}>
                  <p style={{ marginBottom: '16px' }}>
                    <Dot style={{ padding: '3px 7px' }}>1</Dot>現在のフォロワー数を入力してください。
                  </p>
                  <TextBoxWrap>
                    <TextBox
                      type="number"
                      placeholder={nowFollower}
                      onChange={(event) => this.setState({ nowFollower: event.target.value })}
                    />
                  </TextBoxWrap>
                </li>
                <li>
                  <p style={{ marginBottom: '16px' }}>
                    <Dot style={{ padding: '3px 7px' }}>2</Dot>Twitterアナリティクスの各項目の数値を入力してください。
                  </p>
                  <TextBoxWrap>
                    <LabelText>ツイート数</LabelText>
                    <TextBox
                      type="number"
                      placeholder={tweetNumber}
                      onChange={(event) => this.setState({ tweetNumber: event.target.value })}
                    />
                  </TextBoxWrap>
                </li>
                <li>
                  <TextBoxWrap>
                    <LabelText>ツイートインプレッション</LabelText>
                    <TextBox
                      type="number"
                      placeholder={tweetImpression}
                      onChange={(event) => this.setState({ tweetImpression: event.target.value })}
                    />
                  </TextBoxWrap>
                </li>
                <li>
                  <TextBoxWrap>
                    <LabelText>プロフィールへのアクセス</LabelText>
                    <div>
                    <TextBox
                      type="number"
                      placeholder={profileAccess}
                      onChange={(event) => this.setState({ profileAccess: event.target.value })}
                    />
                    </div>
                  </TextBoxWrap>
                </li>
                <li>
                  <TextBoxWrap>
                    <LabelText>新しいフォロワー数</LabelText>
                    <TextBox
                      type="number"
                      placeholder={newFollower}
                      onChange={(event) => this.setState({ newFollower: event.target.value })}
                    />
                  </TextBoxWrap>
                </li>
              </ul>
              <div className="output-button">
                <SubmitButton type="submit" value="分析する" />
              </div>
            </form>
          </Card>
          <p
            style={{ fontSize: '12px', textAlign: 'center', color: '#aaa' }}
          >スポンサードリンク</p>
          <GoogleAds
            client="ca-pub-4507356323905232"
            slot="2679871912"
            className="adsbygoogle"
            format="auto"
            style={{display: 'block'}}
          />
        </MainContent>
        <Footer>
          <MainContent>
            <div style={{ marginBottom: '20px', fontSize: '14px' }}>
              <Link to='/' style={{ marginRight: '12px'}}>トップ</Link> 
              <Link to='/privacy-policy'>プライバシーポリシー</Link> 
            </div>
            <p>© 2018 <a href="https://twitter.com/yu_webmemo" target="_blank" rel="noopener noreferrer">@yu_webmemo</a> & <a href="https://twitter.com/matsu_marketer" target="_blank" rel="noopener noreferrer">@matsu_marketer</a></p>
          </MainContent>
        </Footer>
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => {
  return {
    resultImpression: app.resultImpression,
    resultProfile: app.resultProfile,
    resultNewFollower: app.resultNewFollower,
    resultTweet: app.resultTweet,
  };
};

export default connect(mapStateToProps, AppActions)(TopScreen);



// WEBPACK FOOTER //
// ./src/TopScreen.js